import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/web.dom-exception.stack.js";
import { ElMessage } from 'element-plus';
import md5 from 'js-md5';
import i18n from '@/lang';
const t = i18n.global.t;
export const jsMd5 = md5;
// Parse the time to string
export const parseTime = (time, cFormat // '{y}-{m}-{d} {h}:{i}:{s}'、'{y}年{m}月{d}日 {h}:{i}:{s}' 自定义格式
) => {
  if (!time) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        // eslint-disable-next-line prefer-regex-literals
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return timeStr;
};
// Check if an element has a class
export const hasClass = (ele, className) => {
  return !!ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};
// Add class to element
export const addClass = (ele, className) => {
  if (!hasClass(ele, className)) ele.className += ' ' + className;
};
// Remove class from element
export const removeClass = (ele, className) => {
  if (hasClass(ele, className)) {
    const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
};
// Toggle class for the selected element
export const toggleClass = (ele, className) => {
  if (!ele || !className) {
    return;
  }
  let classString = ele.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  ele.className = classString;
};
export const judgeClient = () => {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // 判断是否是 android终端
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 判断是否是 iOS终端
  if (isAndroid) {
    return 'android';
  } else if (isIOS) {
    return 'ios';
  } else {
    return 'pc';
  }
};
/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  const temp = url;
  const search = temp.substring(temp.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}
// 判断是否是object
export function isObj(object) {
  return object && typeof object === 'object' && Object.prototype.toString.call(object).toLowerCase() === '[object object]';
}
// 判断是否是array
export function isArray(object) {
  return Object.prototype.toString.call(object) === '[object Array]';
}
// 判断基本类型和复杂类型是否为空
export function isEmpty(val) {
  let flag = false;
  if (val) {
    const type = Object.prototype.toString.call(val); // [object Object] // [object Array]
    switch (type) {
      case '[object Object]':
        if (JSON.stringify(val) === '{}') {
          flag = true;
        }
        break;
      case '[object Array]':
        if (val.length === 0 || val === false) {
          flag = true;
        }
        break;
    }
  } else {
    if (val === 0) {
      flag = false;
    } else {
      flag = true;
    }
  }
  return flag;
}
// 复制文本功能
export function copyText(data) {
  let res = false;
  if (data) {
    try {
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      const newInput = document.createElement('input');
      // 将入参赋值给input的value值
      newInput.value = data;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy');
      // 清空输入框
      newInput.remove();
      res = true;
    } catch (err) {
      console.warn(err);
    }
  }
  return res;
}
// 通过类名获取元素高度
export const getHightByClass = function (eles) {
  const getEleNum = document.getElementsByClassName(eles) || document.getElementById(eles);
  const eleHeight = getEleNum[0] ? getEleNum[0].clientHeight : getEleNum.clientHeight;
  return eleHeight || 0;
};
// 获取高度
export const getElementHight = function (eles, nums, type = '-') {
  const getEleNum = document.getElementsByClassName(eles) || document.getElementById(eles);
  const eleHeight = getEleNum[0] ? getEleNum[0].clientHeight : getEleNum.clientHeight;
  if (!eleHeight) return 0;
  let resultNum = 0;
  if (type === '-') {
    resultNum = eleHeight - nums;
  } else if (type === '+') {
    resultNum = eleHeight + nums;
  }
  return resultNum;
};
export function downloadFile(response, fileName) {
  if (!fileName) {
    console.log(response.headers['content-disposition'].split('filename='));
    fileName = response.headers['content-disposition'].split('filename=')[1];
    // 去掉双引号
    // eslint-disable-next-line no-useless-escape
    fileName = fileName.replace(/\"/g, '');
    // iso8859-1的字符转换成中文
    fileName = decodeURI(escape(fileName));
  }
  const blob = new Blob([response]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a'); // 创建a标签
  link.href = url;
  link.download = fileName;
  link.click();
  document.body.appendChild(link);
  URL.revokeObjectURL(url); // 释放内存
}
export const getList = (domainList, filename) => {
  return domainList.filter(item => {
    return item.Fieldname === filename;
  });
};
export const handleText = (list, code) => {
  let text = '';
  let array = [];
  if (list && list.length > 0) {
    array = list.filter(item => {
      return item.const === code;
    });
    if (array.length > 0) {
      text = array[0].title;
    }
  }
  return text;
};
// 获取当前日期
export const getCurrentDate = () => {
  const nowDate = new Date();
  const date = {
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
    date: nowDate.getDate()
  };
  const newmonth = date.month > 10 ? date.month : '0' + date.month;
  const day = date.date >= 10 ? date.date : '0' + date.date;
  return date.year + '-' + newmonth + '-' + day;
};
// 金额验证
export const amountValidation = amount => {
  const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
  return reg.exec(amount);
};
/**
 * 对象数组去重
 * @param arr 对象数组
 * @param prop 根据此属性去重
 * @returns
 */
export function arrDistinctByProp(arr, prop) {
  return arr.filter((item, index, self) => {
    return self.findIndex(s => s[prop] === item[prop]) === index;
  });
}
/**
 * 数组元素交换位置
 * @param {array} arr 数组
 * @param {number} index1 添加项目的位置
 * @param {number} index2 删除项目的位置
 * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
 */
export function swapArray(arr, index1, index2) {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0];
  return arr;
}
export const handleMessage = (type, message) => {
  ElMessage({
    showClose: true,
    message,
    type
  });
};
// 处理表格金额对齐方式
export const handleAmountAlign = (item, amountItems) => {
  return amountItems.includes(item) ? 'right' : 'center';
};
// 检测后端返回报错并抛出信息的方法，没报错的话可以在then里面执行后续动作
export function checkErrMsg(res) {
  return new Promise((resolve, reject) => {
    const msgSet = res.d?.ContMsgSet?.results || [];
    const msgs = msgSet.filter(d => d.Type === 'E');
    if (msgs.length) {
      const duration = 3000 * msgs.length;
      const showClose = msgSet.length >= 3;
      const msgHTML = msgs.reduce((prev, curr) => {
        return prev + `<div style="${prev.length > 0 ? 'margin-top:8px' : ''}">${curr.MessageText}</div>`;
      }, '');
      ElMessage({
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: msgHTML,
        duration,
        showClose
      });
      resolve(false);
    } else {
      resolve(true);
    }
  });
}
// 将上传文件处理成base64文件流
export const getBase64 = file => {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader();
    let result = '';
    reader.readAsDataURL(file);
    reader.onload = function () {
      result = reader.result;
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.onloadend = function () {
      resolve(result);
    };
  });
};
export const b64toBlob = b64Data => {
  const arr = b64Data.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
};
export const downloadBase64File = (b64Data, file) => {
  const blob = b64toBlob(b64Data);
  const url = window.URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = file;
  downloadLink.click();
};
export function getBgyUploadConfigs(env, user) {
  const configs = {
    data: {
      fileBusinessDomain: 'Kr6MdJviNPnDN6bPpYrp',
      fileProject: 'project100001',
      fileType: '-qpJR8Txk5bNWZo50TDB',
      fileSourceSystem: 'ysWmeXRODZPrFgkAMf0Z'
    },
    action: '/integration-api/platform-file/file/upload/query',
    previewInfo: {
      bip: user.bip || '',
      name: user.name,
      tenantKey: '5c38eb06-d28f-4f06-afee-e7fbf9516d7e'
    },
    requestDomain: 'https://yth-sit.countrygarden.com.cn',
    Authorization: `Bearer ${localStorage.getItem('cloud_authorization')}`
  };
  // if (env === 'production' || env === 'prod') {
  //   configs.requestDomain = 'https://yth.countrygarden.com.cn'
  // }
  return configs;
}
export const validateMobilePhone = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  // const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  const reg = /^1\d{10}$/;
  if (val === '') {
    return Promise.reject(new Error(t('pc-utils-0')));
  }
  if (!reg.test(val)) {
    return Promise.reject(new Error(t('pc-utils-1')));
  }
  return Promise.resolve();
};
export const validateIdCard = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  if (val === '') {
    return Promise.reject(new Error(t('pc-utils-2')));
  }
  if (!reg.test(val)) {
    return Promise.reject(new Error(t('pc-utils-3')));
  }
  return Promise.resolve();
};
export const validateEmail = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
  if (val === '') {
    return Promise.reject(new Error(t('pc-utils-4')));
  }
  if (!reg.test(val)) {
    return Promise.reject(new Error(t('pc-utils-5')));
  }
  return Promise.resolve();
};
export const validatePassword = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  const reg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
  if (val === '') {
    return Promise.reject(new Error(t("pc-login-tab-0-3")));
  }
  if (!reg.test(val)) {
    return Promise.reject(new Error(t('pc-utils-6')));
  }
  return Promise.resolve();
};
// 网址验证
export const validateWebsite = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  const reg = /(([\w-][\w-\s]*[\w-]+[$$]?$)|([\w-][$$]?$))/;
  if (val === '') {
    return Promise.reject(new Error(t('pc-utils-7')));
  }
  if (val !== '' && !reg.test(val)) {
    return Promise.reject(new Error(t('pc-utils-8')));
  }
  return Promise.resolve();
};
export const validateComPhone = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  if (val.length > 0) {
    const reg = /^(\d{3,4}|\d{3,4}-)?\d{7,14}$/;
    if (val === '') {
      return Promise.reject(new Error(t('pc-utils-9')));
    }
    if (!reg.test(val)) {
      return Promise.reject(new Error(t('pc-utils-10')));
    }
    return Promise.resolve();
  }
  return Promise.resolve();
};
export const validateComTax = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  if (val.length > 0) {
    const reg = /^(\d{3,4}|\d{3,4}-)?\d{7,8}$/;
    if (!reg.test(val)) {
      return Promise.reject(new Error(t('pc-utils-11')));
    }
    return Promise.resolve();
  }
  return Promise.resolve();
};
export const validateNum = (rule, value) => {
  let val = value;
  if (value === undefined) {
    val = rule.cellValue;
  }
  if (val.length > 0) {
    if (isNaN(val)) {
      return Promise.reject(new Error(t('pc-utils-12')));
    }
    return Promise.resolve();
  }
  return Promise.resolve();
};